/**
 * @flow
 * @relayHash 8ffdec39948bbf7bf41e917c7cab19cf
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteReferenceInput = {|
  id: string,
  clientMutationId?: ?string,
|};
export type DeleteReferenceMutationVariables = {|
  input: DeleteReferenceInput
|};
export type DeleteReferenceMutationResponse = {|
  +deleteReference: ?{|
    +isDeleted: ?boolean
  |}
|};
export type DeleteReferenceMutation = {|
  variables: DeleteReferenceMutationVariables,
  response: DeleteReferenceMutationResponse,
|};
*/


/*
mutation DeleteReferenceMutation(
  $input: DeleteReferenceInput!
) {
  deleteReference(input: $input) {
    isDeleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteReferenceInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteReference",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteReferencePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isDeleted",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteReferenceMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteReferenceMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteReferenceMutation",
    "id": null,
    "text": "mutation DeleteReferenceMutation(\n  $input: DeleteReferenceInput!\n) {\n  deleteReference(input: $input) {\n    isDeleted\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b3076ef469b5d02db41406d55bf3c490';
module.exports = node;
